import { createContext } from "preact";
import { useContext } from "preact/hooks";
import { AppSchema } from "../../instant.schema.ts";
import { InstaQLEntity } from "@instantdb/admin";

export type DBUser = InstaQLEntity<AppSchema, "users">;

type UserContextType = {
  dbUser: DBUser | null;
  isLoading: boolean;
  error: unknown;
};

export const UserContext = createContext<UserContextType>({
  dbUser: null,
  isLoading: true,
  error: null,
});

export const useUser = () => useContext(UserContext);
